export const REMEMBER_ME = '__rememberMe';
export const PREF_DARK_MODE = '__pref_dark_mode';
